import dedent from 'ts-dedent'
import {
  GetOutputSchemaParams,
  Provider,
  TableSchema,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { SelectWorkflowComponent } from './common/selectcomponent'

class PointFromStaticLatLon extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.pointfromstaticlatlon',
        group: 'Spatial Constructors',
        title: 'Point from Static LatLon',
        description: `
      This component creates a new table containing a single row with a single point geography.
      `
      },
      [
        {
          name: 'lon',
          type: WorkflowComponentParamType.Number,
          title: 'Longitude',
          min: -180,
          max: 180
        },
        {
          name: 'lat',
          type: WorkflowComponentParamType.Number,
          title: 'Latitude',
          min: -90,
          max: 90
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return `SELECT ST_GEOGPOINT(${params.lon}, ${params.lat}) geo`
      case Provider.DatabricksRest:
        return dedent`SELECT /*+ REPARTITION(40) */
                  ${connection.processOutputGeogColumn(`ST_POINT(${params.lon}, ${params.lat})`)} geo`
      default:
        return `SELECT ${connection.processOutputGeogColumn(`ST_POINT(${params.lon}, ${params.lat})`)} geo`
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  getOutputSchema({ connection }: GetOutputSchemaParams): TableSchema {
    return [
      {
        name: 'geo',
        type: connection.getGeoDataType()
      }
    ]
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.Postgres, Provider.Redshift, Provider.Snowflake, Provider.DatabricksRest]
  }
}

export { PointFromStaticLatLon }
